function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-tabs';
var genTabsStyle = function genTabsStyle(token) {
  var _extends2, _ref;
  return _ref = {}, _ref[antPrefixCls] = _extends((_extends2 = {}, _extends2[antPrefixCls + "-tab" + antPrefixCls + "-tab-active " + antPrefixCls + "-tab-btn"] = {
    color: token.activeColor,
    outline: 'none !important'
  }, _extends2['.ant-tabs-tab-remove'] = {
    padding: 0
  }, _extends2['>.ant-tabs-nav .ant-tabs-nav-add'] = {
    border: 'none',
    color: token.colorTextQuaternary,
    '&:hover': {
      color: token.colorTextSecondary
    },
    '&:active': {
      color: token.colorText
    }
  }, _extends2), genTabStyle(token)), _ref;
};
var genSizeStyle = function genSizeStyle(token) {
  var _ref2;
  return _ref2 = {}, _ref2[antPrefixCls + "-small " + antPrefixCls + "-tab+" + antPrefixCls + "-tab"] = {
    margin: '0 0 0 24px'
  }, _ref2[antPrefixCls + "-large " + antPrefixCls + "-tab+" + antPrefixCls + "-tab"] = {
    margin: '0 0 0 32px'
  }, _ref2;
};
var genTabStyle = function genTabStyle(token) {
  var _tabCls, _ref3;
  var tabCls = antPrefixCls + "-tab";
  return _ref3 = {}, _ref3[tabCls] = (_tabCls = {
    // padding: `${token.paddingXXS}px 8px`,
    marginBottom: '1px',
    color: token.colorInfoText,
    '&-btn, &-remove': {
      '&:focus:not(:focus-visible), &:active': {
        color: token.activeColor
      }
    },
    '&:hover': {
      color: token.colorInfoTextActive
    }
  }, _tabCls["&" + tabCls + "-active " + tabCls + "-btn"] = {
    color: token.activeColor
  }, _tabCls["&" + tabCls + "-disabled"] = {
    color: token.disableColor,
    cursor: 'not-allowed'
  }, _tabCls["&" + tabCls + "-disabled " + tabCls + "-btn, &" + tabCls + "-disabled " + antPrefixCls + "-remove"] = {
    '&:focus, &:active': {
      color: token.disableColor
    }
  }, _tabCls[".anticon"] = {
    marginRight: '4px'
  }, _tabCls), _ref3;
};
var genTopBottomInkBar = function genTopBottomInkBar(token) {
  var _ref4, _ref5;
  return _ref5 = {}, _ref5["> " + antPrefixCls + "-nav, > div > " + antPrefixCls + "-nav"] = (_ref4 = {
    '&::before': {
      // 不显示nav下方灰色border
      borderBottom: 'none'
    }
  }, _ref4[antPrefixCls + "-ink-bar"] = {
    height: token.inkBarSize,
    borderRadius: '2px'
  }, _ref4), _ref5;
};
var genPositionStyle = function genPositionStyle(token) {
  var _ref6, _ref7, _ref8, _ref9, _ref0;
  return _ref0 = {}, _ref0[antPrefixCls + "-bottom"] = genTopBottomInkBar(token), _ref0[antPrefixCls + "-top"] = genTopBottomInkBar(token), _ref0["&" + antPrefixCls + "-top, &" + antPrefixCls + "-bottom"] = (_ref7 = {}, _ref7["> " + antPrefixCls + "-nav"] = (_ref6 = {}, _ref6[antPrefixCls + "-ink-bar"] = {
    height: token.inkBarSize + "px"
  }, _ref6), _ref7), _ref0["&" + antPrefixCls + "-left, &" + antPrefixCls + "-right"] = (_ref9 = {}, _ref9["> " + antPrefixCls + "-nav"] = (_ref8 = {}, _ref8[antPrefixCls + "-ink-bar"] = {
    width: token.inkBarSize + "px"
  }, _ref8), _ref9), _ref0;
};
var genCardStyle = function genCardStyle(token) {
  var _ref1, _ref10, _ref11, _ref12, _ref13, _ref14;
  return _ref14 = {}, _ref14[antPrefixCls + "-card"] = (_ref13 = {}, _ref13["> " + antPrefixCls + "-nav, > div > " + antPrefixCls + "-nav"] = (_ref12 = {}, _ref12[antPrefixCls + "-tab"] = {
    background: token.hoverBGColor,
    color: token.defaultColor,
    borderColor: token.hoverCardBGBorderColor,
    padding: "5px 16px !important",
    '&:hover': {
      color: token.colorInfoTextActive
    }
  }, _ref12[antPrefixCls + "-tab-active"] = (_ref1 = {
    borderColor: token.hoverCardBGBorderColor,
    backgroundColor: token.activeCardColor,
    borderBottom: '1px solid #fff !important'
  }, _ref1[antPrefixCls + "-tab-btn"] = {
    color: token.inkBarColor
  }, _ref1), _ref12[antPrefixCls + "-nav-wrap"] = (_ref11 = {}, _ref11[antPrefixCls + "-nav-list " + antPrefixCls + "-tab"] = (_ref10 = {}, _ref10["&" + antPrefixCls + "-tab-active, &" + antPrefixCls + "-tab-active " + antPrefixCls + "-tab-btn"] = {
    color: token.inkBarColor,
    borderColor: token.hoverCardBGBorderColor,
    backgroundColor: token.activeCardColor
  }, _ref10), _ref11), _ref12[antPrefixCls + "-tab-disabled"] = {
    color: token.disableColor,
    borderColor: token.hoverCardBGBorderColor,
    backgroundColor: token.hoverBGColor,
    '&:hover': {
      color: token.disableColor,
      borderColor: token.hoverCardBGBorderColor,
      backgroundColor: token.hoverBGColor
    }
  }, _ref12), _ref13[antPrefixCls + "-nav"] = {
    '&::before': {
      position: 'absolute',
      right: 0,
      left: 0,
      borderBottom: '1px solid rgba(0,0,0,.06) !important',
      content: '""'
    }
  }, _ref13[antPrefixCls + "-tab"] = {
    marginBottom: '0px !important'
  }, _ref13), _ref14;
};
var genDropdownStyle = function genDropdownStyle(token) {
  var _ref15, _ref16;
  return _ref16 = {}, _ref16[antPrefixCls + "-dropdown"] = (_ref15 = {}, _ref15[antPrefixCls + "-dropdown-menu"] = {
    padding: "4px 0px",
    '&-item': {
      height: '32px',
      cursor: 'pointer',
      color: token.colorTextSecondary,
      '&:hover': {
        color: token.defaultColor,
        backgroundColor: token.hoverBGColor
      },
      '&:active': {
        color: token.colorText
      }
    }
  }, _ref15), _ref16;
};
var tabsStyleFn = function tabsStyleFn(TabsToken) {
  return [genTabsStyle(TabsToken), genSizeStyle(), genPositionStyle(TabsToken), genCardStyle(TabsToken), genDropdownStyle(TabsToken)];
};

export { tabsStyleFn };
